<template>
    <div>
        <div class="w-100 bgray-200 mb-5 fw-400">
            <h2 class="py-5 fw-400 text-center"> LIST OF QUESTION TEMPLATES</h2>
        </div>

        <template v-if="is_template_loaded === true">
            <b-container class="pt-3 mb-45">
                <b-row>
                    <b-col cols="12" xl="6">
                        <h4 class="fw-600 mb-0"> 생성/사용중인 질문지 </h4>
                    </b-col>
                    <b-col cols="12" xl="6">
                        <div class="d-flex flex-column align-items-end">
                            <div class="d-flex justify-content-end mb-3">
                                <b-btn variant="dark-border"
                                       class="f-105 fw-500 mr-2"
                                       size="sm"
                                       :disabled="is_parsing_criteriaDefinition"
                                       @click="newTemplate"
                                >
                                    <fa icon="plus" class="mr-2"></fa>
                                    새 질문지
                                </b-btn>
                                <b-btn variant="dark-border"
                                       class="f-105 fw-500"
                                       size="sm"
                                       :to="{ name: 'ManagingCriteria' }"
                                       :disabled="is_parsing_criteriaDefinition"
                                >
                                    <fa icon="flag" class="mr-2"></fa>
                                    Criteria 관리
                                </b-btn>
                            </div>
                            <div class="d-flex justify-content-end">
                                <b-btn variant="dark-border"
                                       class="fw-500 mr-2"
                                       size="sm"
                                       :disabled="is_parsing_criteriaDefinition"
                                       @click="parseCriteriaDefinition"
                                >
                                    <fa icon="tasks" class="mr-1"></fa>
                                    전체 질문지 답변 파싱 및 저장
                                </b-btn>
                                <b-btn variant="dark-border"
                                       class="fw-500"
                                       size="sm"
                                       :to="{ name: 'ManagingParserValues' }"
                                       :disabled="is_parsing_criteriaDefinition"
                                >
                                    <fa icon="flag" class="mr-1"></fa>
                                    Parser Value 관리
                                </b-btn>
                            </div>
                        </div>

                    </b-col>
                </b-row>
            </b-container>

            <b-container v-if="on_going_templates && archived_templates" class="py-0 py-md-3">
                <div v-if="on_going_templates" class="mb-5">
                    <b-table-simple
                        class="rep-table"
                        responsive
                        hover
                    >
                        <b-thead>
                            <b-tr class="">
                                <b-td style="width: 15%">최종편집일</b-td>
                                <b-td> 템플릿명</b-td>
                                <b-td> 연결된 캠페인</b-td>
                                <b-td class="text-center"> 편집</b-td>
                                <b-td> 삭제</b-td>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(item, index) in on_going_templates"
                                  :key="index"
                            >
                                <b-td :class="[item.type === 'owner' ? '' : '', 'py-2 f-95']"> {{ item.time_stamp }}
                                </b-td>
                                <b-td :class="[item.type === 'owner' ? 'fw-500' : '', 'py-2']">{{
                                        item.template_name
                                    }}
                                </b-td>
                                <b-td :class="[item.type === 'owner' ? '' : '', 'f-95 py-2']">
                                    <template v-if="check_multiple_campaign(item?.campaigns)">
                                        <div>
                                            <div class="d-flex justify-content-between align-items-center">
                                              <span>
                                                {{ item.campaign_name }}
                                                <b-badge pill variant="info" class="ml-1">
                                                  외 {{ item.campaigns.length - 1 }}개
                                                </b-badge>
                                              </span>
                                                <b-button
                                                    :id="'on_going_campaign-toggle-btn-' + item.template_id"
                                                    v-b-toggle="'on_going_campaign-collapse-' + item.template_id"
                                                    variant="outline-secondary"
                                                    size="sm"
                                                    class="ml-2 px-2 py-1"
                                                >
                                                    캠페인 목록
                                                </b-button>
                                            </div>

                                            <b-collapse :id="'on_going_campaign-collapse-' + item.template_id" class="mt-2">
                                                <b-list-group flush>
                                                    <b-list-group-item
                                                        v-for="campaign in item.campaigns"
                                                        :key="campaign.campaign_id"
                                                        class="py-1 px-2 d-flex align-items-center justify-content-between"
                                                        style="font-size: 0.9em; "
                                                    >
                                                        <div>
                                                            {{ campaign.campaign_name }} 
                                                        </div>
                                                        <div>
                                                             <b-badge pill :variant="variantCampaignState[campaign.campaign_state]"> {{campaign.campaign_state}}</b-badge>
                                                        </div>
                                                    </b-list-group-item>
                                                </b-list-group>
                                            </b-collapse>
                                        </div>
                                    </template>
                                    <template v-else>
                                        {{ item.campaign_name }}
                                    </template>
                                </b-td>
                                <b-td v-if="checkAllowed(item.type, is_admin, 4) === true" class="py-2 text-center">
                                    <b-button
                                        v-b-tooltip.hover
                                        class="py-1 px-2 mr-2"
                                        variant="dark-border"
                                        small
                                        title="수정/편집"
                                        :disabled="is_parsing_criteriaDefinition"
                                        @click.stop="editTemplate(item)"
                                    >
                                        <fa icon="pen"></fa>
                                    </b-button>
                                    <b-button
                                        v-b-tooltip.hover
                                        class="py-1 px-2"
                                        variant="dark-border"
                                        :to="{ name: 'EditingTemplateTranslation', params: { template_code: item.template_code } }"
                                        small
                                        title="번역 수정"
                                        :disabled="is_parsing_criteriaDefinition"
                                    >
                                        <fa icon="language"></fa>
                                    </b-button>
                                </b-td>
                                <b-td v-if="checkAllowed(item.type, is_admin, 4) === true" class="py-2">
                                    <b-button
                                        v-b-tooltip.hover.right
                                        class="py-1 px-2"
                                        variant="dark-border"
                                        small
                                        title="삭제"
                                        :disabled="is_parsing_criteriaDefinition"
                                        @click.stop="deleteTemplate(item)"
                                    >
                                        <fa icon="trash-alt"></fa>
                                    </b-button>
                                </b-td>
                                <b-td v-else
                                      colspan="2"
                                >
                                    권한 없음
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </div>

                <hr class="border-0 pb-5">

                <div v-if="archived_templates">
                    <h4 class="mb-5 gray-500 fw-600">
                        <span
                            v-b-tooltip.hover
                            title="캠페인이 종료되어 사용중이지 않은 질문지 입니다."
                        >
                            사용 종료된 질문지
                        </span>
                    </h4>
                    <b-table-simple class="rep-table" responsive hover>
                        <b-thead>
                            <b-tr
                                class="border-bottom border-color-gray-300 border-width-2 border-color-gray-300 gray-600">
                                <b-td style="width:15%"> 최종편집일</b-td>
                                <b-td>템플릿명</b-td>
                                <b-td style="width:23%">연결된 캠페인</b-td>
                                <b-td>편집</b-td>
                                <b-td>삭제</b-td>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(item, index) in archived_templates"
                                  :key="index"
                                  class="gray-550"
                            >
                                <b-td :class="[item.type === 'owner' ? '' : '', 'py-2 f-95']">
                                    {{ item.time_stamp }}
                                </b-td>
                                <b-td :class="[item.type === 'owner' ? 'f w-500' : '', 'py-2']">
                                    {{ item.template_name }}
                                </b-td>
                                <b-td :class="[item.type === 'owner' ? '' : '', 'f-95 py-2']">
                                    <template v-if="check_multiple_campaign(item?.campaigns)">
                                        <div>
                                            <div class="d-flex justify-content-between align-items-center">
                                                                              <span>
                                                                                {{ item.campaign_name }}
                                                                                <b-badge pill variant="info"
                                                                                         class="ml-1">
                                                                                  외 {{ item.campaigns.length - 1 }}개
                                                                                </b-badge>
                                                                              </span>
                                                <b-button
                                                    :id="'archived_campaign-toggle-btn-' + item.template_id"
                                                    v-b-toggle="'archived_campaign-collapse-' + item.template_id"
                                                    variant="outline-secondary"
                                                    size="sm"
                                                    class="ml-2 px-2 py-1"
                                                >
                                                    캠페인 목록
                                                </b-button>
                                            </div>

                                            <b-collapse :id="'archived_campaign-collapse-' + item.template_id" class="mt-2">
                                                <b-list-group flush>
                                                    <b-list-group-item
                                                        v-for="campaign in item.campaigns"
                                                        :key="campaign.campaign_id"
                                                        class="py-1 px-2"
                                                        style="font-size: 0.9em;"
                                                    >
                                                        {{ campaign.campaign_name }}
                                                    </b-list-group-item>
                                                </b-list-group>
                                            </b-collapse>
                                        </div>
                                    </template>
                                    <template v-else>
                                        {{ item.campaign_name }}
                                    </template>
                                </b-td>
                                <b-td v-if="checkAllowed(item.type, is_admin, 4) === true" class="py-2">
                                    <b-button v-b-tooltip.hover.left class="py-1 px-2" variant="dark-border" small
                                              title="수정/편집" @click.stop="editTemplate(item)">
                                        <fa icon="pen"></fa>
                                    </b-button>
                                    <b-button v-b-tooltip.hover.right class="py-1 px-2" variant="dark-border" small
                                              title="복제" @click.stop="copyTemplate(item)">
                                        <fa icon="copy"></fa>
                                    </b-button>
                                </b-td>
                                <b-td v-if="checkAllowed(item.type, is_admin, 4) === true" class="py-2">
                                    <b-button v-b-tooltip.hover.right class="py-1 px-2" variant="dark-border" small
                                              title="삭제" @click.stop="deleteTemplate(item)">
                                        <fa icon="trash-alt"></fa>
                                    </b-button>
                                </b-td>
                                <b-td v-else colspan="2"> 권한 없음</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </div>
                <hr class="border-0 bottom-space">
            </b-container>
            <b-container v-else class="px-0 px-md-5 py-0 py-md-3">
                <div class="mt-2 py-2 text-center gray-600 bgray-200"> 저장된 질문지가 없습니다. 새 질문지를 만들어 주세요.</div>
            </b-container>
        </template>
        <template v-else>
            <b-container class="px-0 px-md-5 py-0 py-md-3">
                <b-skeleton-table
                    :rows="4"
                    :columns="4"
                    :table-props="{ bordered: false, striped: false }"
                ></b-skeleton-table>
            </b-container>
        </template>
    </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';


export default {
    props: {
        initiate_list: {type: Boolean, default: true}
    },
    data() {
        return {
            all_templates: [],
            is_template_loaded: false,
            deletable_item: '',
            is_parsing_criteriaDefinition: false,
            variantCampaignState:{
                '답변중': 'warning',
                '생성/편집': 'primary',
                '종료': 'secondary'
            }
        };
    },
    computed: {
        ...mapState(['user_id', 'is_admin']),
        on_going_templates() {
            let temp_on_going = this.all_templates.filter(item => item.campaign_state !== '종료');
            return temp_on_going.sort((b, a) => new Date(a.time_stamp).getTime() - new Date(b.time_stamp).getTime());
        },
        archived_templates() {
            let temp_archived = this.all_templates.filter(item => item.campaign_state === '종료');
            return temp_archived.sort((b, a) => new Date(a.time_stamp).getTime() - new Date(b.time_stamp).getTime());
        },
        check_multiple_campaign() {
            return (campaigns) => {
                return campaigns?.length > 1;
            };
        }
    },
    async created() {
        await this.readTemplates(this.user_id);
        this.update_answer_company({});
    },
    methods: {
        ...mapMutations('questions', ['change_edit_mode', 'update_answer_company']),
        async readTemplates(user_id) {
            try {
                const response = await this.$axios.get('/read_template_list', {
                    params: {user_id: user_id, mode: 'qesg_assessment'}
                });

                let result = response.data.templates;
                let all_templates = [];

                for (var i = 0; i < result.length; i++) {
                    const {
                        template_id, template_name, user_id, template_code, type, time_stamp,
                        campaign_name, campaign_state, template_contents, campaigns
                    } = result[i];

                    let parsed_template = {
                        template_id, template_name, user_id, template_code, type, time_stamp,
                        campaign_name, campaign_state, campaigns
                    };

                    parsed_template.template_contents = template_contents !== ''
                        ? JSON.parse(result[i].template_contents)
                        : [];

                    all_templates.push(parsed_template);
                }
                this.all_templates = all_templates.filter(item => item.user_id !== null);

                this.is_template_loaded = true;
            } catch (error) {
                console.log(' ~ error => ', error);
                if (error.response) {
                    if (error.response.status === 401) {
                        alert(this.$t('다중 로그인 등 권한 오류가 발생했습니다. 다시 로그인해 주십시오.'));
                        this.$store.dispatch('logout').then(() => {
                            this.$router.push({name: 'Login'});
                        });
                    }
                }
            }
        },
        editTemplate(new_template) {
            this.change_edit_mode(true);
            this.$store.commit('update_template_tree', new_template);
            this.$router.push({
                name: 'EditingTemplate',
                query: {value_new: false, template_id: new_template.template_code}
            });
        },
        async deleteTemplate(item) {
            try {
                let result = confirm(`${item.template_name} 템플릿을 삭제하시겠습니까?`);
                if (result) {
                    let formData = new FormData();
                    formData.append('template_id', item.template_id);
                    await this.$axios.post('/delete_template', formData);
                    this.$emit('toast-success', '알림', `${item.template_name}을 성공적으로 삭제하였습니다.`);

                    const i = this.all_templates.findIndex((x) => x.template_id === item.template_id);
                    if (i > -1) this.all_templates.splice(i, 1);
                }
            } catch (error) {
                console.log(error);
            }
        },
        async copyTemplate(item) {
            try {
                let formData = new FormData();
                formData.append('template_code', item.template_code);

                await this.$axios.post('/copy_template', formData);
                await this.readTemplates(this.user_id);
            } catch (error) {
                console.log(error);
            }
        },
        newTemplate() {
            this.change_edit_mode(true);
            this.$router.push({name: 'EditingTemplate', query: {value_new: true}});
        },
        async parseCriteriaDefinition(mode = 'total', campaign_id) {
            let _is_parsing_criteriaDefinition_success = true;
            try {
                this.is_parsing_criteriaDefinition = true;

                const parsingDefinitionFormData = new FormData();
                parsingDefinitionFormData.append('type', 'figure');
                if (mode === 'campaign' && campaign_id) {
                    parsingDefinitionFormData.append('campaign_id', campaign_id);
                }

                await this.$axios.post('/parser/values', parsingDefinitionFormData);

                _is_parsing_criteriaDefinition_success = true;
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        await this.commonLogout();
                    }
                }

                _is_parsing_criteriaDefinition_success = false;
            } finally {
                if (!_is_parsing_criteriaDefinition_success) {
                    alert('죄송합니다. 질문지 답변 파싱 및 저장 중 장애가 발생했습니다.');
                }

                this.is_parsing_criteriaDefinition = false;
            }
        },
        checkAllowed(campaign_type, user_admin_level) {
            if (user_admin_level >= 4) return true;
            if (campaign_type == 'owner') return true;

            return false;
        }
    }
};
</script>

<style scoped>
.f-95 {
    font-size: 0.95rem; /* 예시 */
}

.b-list-group-item {
    border-left: 0;
    border-right: 0;
}

.b-list-group-item:first-child {
    border-top: 0;
}

.b-list-group-item:last-child {
    border-bottom: 0;
}

</style>
